<!--领队报名-->
<template>
  <div>
    <div>
      <van-nav-bar
        title="信息填写"
        left-text="返回"
        :right-text="bmLx === 'GR' ? '新增报名' : ''"
        left-arrow
        @click-left="onTopClickLeft"
        @click-right="onTopClickRight"
      />
    </div>
    <div style="background: #fff;">
      <div
        style="text-align: center;padding: 10px;font-size: 15px;font-weight: 600;border-bottom: 1px solid #e1e1e1;margin-left: 10px;
    margin-right: 10px;"
      >
        {{ SSMC }}（{{ SSLX }}）
      </div>
    </div>

    <!-- 如果检测到这个人名下有队伍信息，则直接显示列表 -->
    <div v-if="isWriteShow === false">
      <div
        style="font-size: 14px;position: relative;background: #fff;padding: 8px 15px;margin-top: 15px;"
        v-for="(item, index) in YBMRYLIST"
        :key="index"
      >
        <div>
          <van-row style="padding-top: 5px;padding-bottom: 15px;">
            <van-col :span="12">
              <div>
                {{
                  item.RYXM1 + (item.RYXM2.length > 0 ? "/" + item.RYXM2 : "")
                }}
              </div>
            </van-col>
            <van-col :span="12">
              <div style="text-align: right;position: relative;">
                <van-icon name="arrow" />
              </div>
            </van-col>
          </van-row>
        </div>
        <div style="text-align: right;">
          <van-button size="mini" type="warning" @click="deleteRyxx(item)"
            >取消报名</van-button
          >
          &nbsp;
          <van-button size="mini" type="info" @click="editorRyInfo(item)">
            编&nbsp;&nbsp;辑
          </van-button>
          <van-button
            size="mini"
            type="danger"
            @click="toPay(item)"
            v-if="item.ISSF === '1'"
          >
            去支付
          </van-button>
        </div>
      </div>
    </div>
    <loading-com />
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
export default {
  name: "GrBmDataIndex",
  components: { LoadingCom },
  data() {
    return {
      isWriteShow: false,
      utilPost: "",
      ssid: "",
      op: "wapGL",
      SSMC: "",
      YBMRYLIST: [],
      xmid: "",
      SSLX: "",
      bmLx: ""
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.xmid = this.$route.query.xmid;
  },
  mounted() {
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {});
    }
    this.mainData();
  },
  methods: {
    mainData() {
      var busData = {
        XMID: this.xmid
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "getGrBmxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.YBMRYLIST = data.content.YBMRYLIST;
        this.SSLX = data.content.SSLX;
        this.SSMC = data.content.SSMC;
      });
    },
    onTopClickLeft() {
      this.$router.go(-1);
    },
    onTopClickRight() {
      if (this.bmLx !== "GR") {
        return;
      }
      this.$router.push({
        path: "/addRyInfo",
        query: {
          ssid: this.ssid,
          xmid: this.xmid,
          bmLx: "GR",
          dwid: "",
          czlx: "ADD"
        }
      });
    },
    editorRyInfo(rowItem) {
      this.$router.push({
        path: "/addRyInfo",
        query: {
          ssid: this.ssid,
          xmid: this.xmid,
          bmLx: "GR",
          dwid: "",
          czlx: "UPT",
          ryid1Param: rowItem.RYID1,
          ryid2Param: rowItem.RYID2
        }
      });
    },
    deleteRyxx(itemRow) {
      // alert(JSON.stringify(itemRow));
      if (!confirm("是否删除?")) {
        return;
      }
      var busData = {
        XMID: this.xmid,
        RYID1: itemRow.RYID1,
        RYID2: itemRow.RYID2
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: this.op, //反射名称
          methodName: "delGrBmxx" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        alert(data.msg);
        this.mainData();
      });
    },
    toPay(item) {
      alert("aa");
      this.$router.push({
        path: "/payIndex",
        query: {
          ssid: this.ssid
        }
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.van-button--round {
  height: 35px;
}
.van-card {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/ReportXm/GrBmDataIndex.vue